import userCompanyActionTypes from "../actions/userCompanyActionTypes";
import { reducerFactory } from "../../common/redux/reducers/reducerFactory";

export const userCompanyReducer = reducerFactory.readReducer(
  userCompanyActionTypes
);
